export const PersonalInformationProvisionConsentText  = `1. 제공받는 자: ㈜매쓰마스터

2. 개인정보 제공 목적
- 회원관리
- 서비스 제공 및 운영
- 마케팅 및 서비스 개선
- 통합 아이디 서비스 제공

3. 개인정보 제공 항목
- 아이스크림 통합회원: 아이디, 비밀번호, 이름, 닉네임, 휴대폰번호, 이메일, 학교명, 학년 정보, 클래스 정보(학생번호, 이름, 접속번호)

4. 개인정보 제공 시 보유 ·  이용 기간
- 회원 탈퇴 시 까지
단, 이용자의 개인정보 보유기간에 대해 별도의 동의를 얻은 경우 또는 관련 법령에 따른 정보 보유 사유에 해당하는 경우 정해진 기간 까지

개인정보 제공 동의에 거부할 수 있으며, 거부 시 아크수학 서비스 이용이 어려울 수 있습니다.
`;